<template>
  <form id="frm_action">
    <div class="p-formgrid">
      <div class="col-6">
        <div class="fontweightbold p-card-field">
          <label class="p-col-fixed txt-right txt-required">Term name</label>
          <div class="p-col">
            <InputText id="name" type="text" v-model="obj_data.name" placeholder="Input" />
          </div>
        </div>

        <div class=" p-card-field ">
          <div class=" box_lat_log duration-unit-wrapper">
            <div class="duration-field">
              <label class="fontweightbold p-col-fixed txt-right txt-required">Duration</label>
              <div class="p-col">
                <InputNumber id="duration" v-model="obj_data.duration" placeholder="Input"    @input="checkPositiveValue('duration')"/>
              </div>
            </div>
            <div class="unit-field">
              <label class="fontweightbold p-col-fixed txt-right txt-required">Unit</label>
              <div class="p-col">
                <v-select
                  :key="key_type_id"
                  :clearable="false"
                  placeholder="Choose"
                  v-model="obj_data.unit_duration"
                  :options="list_unit_duration"
                  :reduce="item => item.id"
                  label="name"
                 
                >
                  <span slot="no-options" @click="$refs.select.open = false">Empty data</span>
                </v-select>
                <input class="input_tmp_validator" id="unit_duration">
              </div>
            </div>

          </div>
        </div>

        <div class=" p-card-field">
          <label class="fontweightbold p-col-fixed txt-right txt-required">Category</label>
          <div class="p-col">
            <v-select  :key="key_type_id" :clearable="false" placeholder="Choose"
              v-model="obj_data.vehicle_category_id" :options="ListvehicleCategory" :reduce="item => item.id"
              label="name" @input="fetchBondFee">
              <span slot="no-options" @click="$refs.select.open = false">Empty data</span>
            </v-select>
            <input class="input_tmp_validator" id="vehicle_category_id">
          </div>
        </div>

        <div class="fontweightbold p-card-field">
          <label class="p-col-fixed txt-right">Bond fee</label>
          <div class="p-col">
            <div class="p-inputgroup">
              <InputNumber v-model="obj_data.bond_fee" :min="0" id="bond_fee" :minFractionDigits="2" :disabled="true"
                placeholder="00.00" />
              <span class="p-inputgroup-addon">$</span>
            </div>
          </div>
        </div>

        <div class="fontweightbold p-card-field">
          <label class="p-col-fixed txt-right txt-required">Price before discount</label>
          <div class="p-col">
            <div class="p-inputgroup">
              <InputNumber v-model="obj_data.price_per_unit_before" :min="0" id="price_per_unit_before" :minFractionDigits="2" :maxFractionDigits="2"
                placeholder="00.00" />
              <span class="p-inputgroup-addon">$</span>
            </div>
          </div>
        </div>

        <div class="fontweightbold p-card-field">
          <label class="p-col-fixed txt-right txt-required">Price after discount</label>
          <div class="p-col">
            <div class="p-inputgroup">
              <InputNumber v-model="obj_data.price_per_unit" :min="0" id="price_per_unit" :minFractionDigits="2" :maxFractionDigits="2"
                placeholder="00.00" />
              <span class="p-inputgroup-addon">$</span>
            </div>
          </div>
        </div>

        <div class="fontweightbold p-card-field">
          <label class="p-col-fixed txt-right txt-required">Booking fee</label>
          <div class="p-col">
            <div class="p-inputgroup">
              <InputNumber v-model="obj_data.booking_fee" :min="0" id="booking_fee" :minFractionDigits="2"
                placeholder="00.00" />
              <span class="p-inputgroup-addon">$</span>
            </div>
          </div>
        </div>

        <div class="fontweightbold p-card-field">
          <label class="p-col-fixed txt-right txt-required">Effective date</label>
          <div class="p-col">
            <Calendar id="effective_date" :key="available_from_key" dateFormat="dd/mm/yy" :showIcon="true" :minDate="today"
              :showClear="true" v-model="obj_data.effective_date" placeholder="DD/MM/YYYY" />
          </div>
        </div>

        <div class="fontweightbold p-card-field div_check">
          <div class="p-col checkbox">
            <Checkbox v-model="obj_data.active" :binary="true" />
            <label class="p-col-fixed txt-right text">Active</label>
          </div>
        </div>
      </div>

      <!-- Toolbar -->
      <Toolbar class="fixed-bottom-toolbar div-button">
        <template slot="right">
          <Button id="back" :label="$constants.TEXT_BUTTON.BACK" @click="backToList()" class="p-button-outlined" />
          <Button v-if="mode == 'edit'" id="edit" :label="$constants.TEXT_BUTTON.EDIT" @click="saveData()"
            class="main-style-button" />
          <Button v-else id="add" :label="$constants.TEXT_BUTTON.ADD" @click="saveData()" class="main-style-button" />
        </template>
      </Toolbar>

      <!-- Delete Dialog -->
      <Dialog header="Delete" :visible.sync="showDeleteDialog" :modal="true">
        Are you sure you want to delete?
        <template #footer>
          <Button label="Delete" @click="deleteData()" class="p-button-danger" />
          <Button label="Cancel" @click="showDeleteDialog = false" class="p-button-warning" />
        </template>
      </Dialog>
    </div>
  </form>
</template>
<script>
export default {
  props: {
    mode: String,
    model: Object,
  },
  data() {
    return {
      available_from_key: 1,
      key_type_id: 1,
      list_unit_duration: [{ id: 1, name: 'Month' }],
      obj_data: {
        vehicle_category_id: null,
        bond_fee: 0,
        active: true,
        unit_duration: 1,
      },
      showDeleteDialog: false,
      ListvehicleCategory: [],
      selectVehicle : '',
      today: new Date()
    };
  },

  async mounted() {
    await this.getLisVehicleCategory(); // Đảm bảo danh sách phương tiện được tải trước
    if (this.model && Object.keys(this.model).length > 0) {
      this.obj_data = this.$commonFuction.convertJsonObject(this.model);
      if (this.obj_data.unit_duration ==='M') {
        this.obj_data.unit_duration = 1;
      }
      this.setInitialBondFee();
    }
  },


  methods: {
    // Tải danh sách các phương tiện
    async getLisVehicleCategory() {
      try {
        var where_key = { deleted: { _eq: false } };
        var list = await this.$CoreService.getLisVehicleCategory(where_key);
        if (list && list.list) {
          this.ListvehicleCategory = list.list;
          console.log('ListvehicleCategory:', this.ListvehicleCategory);
          
        } else {
          console.log('No data returned');
        }
      } catch (error) {
        console.error('Error loading vehicle categories:', error);
      }
    },
    setInitialBondFee() {
      if (this.obj_data.vehicle_category_id) {
        const selectedCategory = this.ListvehicleCategory.find(category => category.id === this.obj_data.vehicle_category_id);
        if (selectedCategory) {
          this.obj_data.bond_fee = selectedCategory.bond_fee || 0;
        }
      }
    },

    // Lấy bond fee dựa trên category đã chọn
    fetchBondFee() {
      const selectedCategory = this.ListvehicleCategory.find(category => category.id === this.obj_data.vehicle_category_id);
      if (selectedCategory) {
        this.obj_data.bond_fee = selectedCategory.bond_fee || 0;
      }
    },
    checkPositiveValue(field) {
      // Chỉ cho phép số dương
      if (this.obj_data[field] < 0) {
        this.obj_data[field] = Math.abs(this.obj_data[field]);
      }
    },
    backToList() {
      this.$emit('back');
    },
    async validateData() {
      this.validationErrors = {};

      // Các trường cần kiểm tra
      const fieldsToValidate = [
        { id: "name", value: this.obj_data.name },
        { id: "duration", value: this.obj_data.duration, minValue: 1 }, // Chỉ được nhập lớn hơn 0
        { id: "unit_duration", value: this.obj_data.unit_duration },
        { id: "vehicle_category_id", value: this.obj_data.vehicle_category_id },
        { id: "price_per_unit_before", value: this.obj_data.price_per_unit_before, minValue: 0 },
        { id: "price_per_unit", value: this.obj_data.price_per_unit, minValue: 0 },
        { id: "booking_fee", value: this.obj_data.booking_fee, minValue: 0 },
        { id: "effective_date", value: this.obj_data.effective_date }
      ];

      let isFormInvalid = false;

      // Kiểm tra từng trường trong fieldsToValidate
      for (let i = 0; i < fieldsToValidate.length; i++) {
        let field = fieldsToValidate[i];
        let inputElement = document.getElementById(field.id);

        if (inputElement && (inputElement.tagName === "INPUT" || inputElement.tagName === "TEXTAREA" || inputElement.tagName === "SELECT")) {
          // Kiểm tra giá trị rỗng
          if (this.$commonFuction.isEmptyObject(field.value)) {
            inputElement.setCustomValidity(this.$constants.MSG_TEXT.INPUT_INVALID_MSG);
            isFormInvalid = true;
          }
          // Kiểm tra giá trị nhỏ hơn giá trị tối thiểu nếu có (minValue)
          else if (field.minValue !== undefined && field.value < field.minValue) {
            inputElement.setCustomValidity('Please enter duration as a positive integer greater than 0');
            isFormInvalid = true;
          }
          // Xóa thông báo lỗi nếu hợp lệ
          else {
            inputElement.setCustomValidity("");
          }
        }
      }
      if(isFormInvalid == false){
        //kiểm tra price_per_unit_before < price_per_unit
        let price_per_unit = document.getElementById("price_per_unit");
        if(this.obj_data.price_per_unit > this.obj_data.price_per_unit_before) {
          price_per_unit.setCustomValidity('Price before discount must be greater than or equal to Price after discount.');
          isFormInvalid = true;
        }else{
          price_per_unit.setCustomValidity("");
        }
      }

      // Kiểm tra tính hợp lệ của toàn bộ form
      let inpObj = document.getElementById("frm_action");
      if (!inpObj.checkValidity() || isFormInvalid) {
        inpObj.reportValidity();
        return true; // Trả về true nếu form không hợp lệ
      }

      return false; // Form hợp lệ
    },



    async saveData() {
      this.$commonFuction.is_loading(true);
      if (await this.validateData()) {
        this.$commonFuction.is_loading(false);
        return;
      }

      // Lưu dữ liệu nếu hợp lệ
      let params = {
        name: this.obj_data.name,
        duration: this.obj_data.duration,
        unit_duration: this.obj_data.unit_duration,
        vehicle_category_id: this.obj_data.vehicle_category_id,
        price_per_unit: this.obj_data.price_per_unit,
        price_per_unit_before: this.obj_data.price_per_unit_before,
        booking_fee: this.obj_data.booking_fee,
        effective_date: this.obj_data.effective_date,
        active: this.obj_data.active
      };

      console.log("saveData params:", params);
      this.$emit("save", params);
    }
  },
};



</script>
<style lang="scss">
.p-formgrid {
  padding-top: 20px;
}

.main-style-button {
  background-color: #FFDF01 !important;
}

div.p-card-field {
  padding: 0px !important;
}

.p-col-fixed {
  padding: 0px !important;
  margin: 0px 0px 0px 9px !important;
}

.duration-unit-wrapper {
  display: flex;
  justify-content: space-between;
}

.duration-field,
.unit-field {
  flex: 1;
  margin-right: 10px;
}

.unit-field {
  margin-right: 0;
}


.fontweightbold {
  font-weight: bold;
}

.p-button-outlined .p-button-label {
  color: #000000 !important;
}


</style>
